import { render } from "./TestRow.vue?vue&type=template&id=2e874fae"
import script from "./TestRow.vue?vue&type=script&lang=js"
export * from "./TestRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__